import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FdsDirectivesModule } from '@fmr-ap153177/fdskit-angular-directives';

@Component({
  selector: 'app-user-agreement',
  standalone: true,
  imports: [CommonModule, FormsModule, FdsDirectivesModule],
  templateUrl: './user-agreement.component.html',
  styleUrls: ['./user-agreement.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserAgreementComponent {
  @Input() showActions = false;
  @Output() accepted = new EventEmitter<void>();

  isAgreed = false;

  onContinue(): void {
    this.accepted.emit();
  }
}
